import pixm1 from '../assets/pixel-m1.jpg'
import pixm2 from '../assets/pixel-m2.jpg'
import pixf1 from '../assets/pixel-f1.jpg'
import pixf2 from '../assets/pixel-f2.jpg'
import { rootStore } from '../StApp'
import { useHistory } from 'react-router'
import { observer } from 'mobx-react-lite'

export const PotMatchIndic = observer(() => {

    const history = useHistory()
    function navToMatchSelction(){
        if(rootStore.matchStore.potMatches.length < 1)
         return
        history.push('/stapp/selectMatches')
    }

    return (
        <div className='relative flex-column center-both ' style={{width: 85, flexShrink: 0}} onClick={navToMatchSelction} >
            <div className='card-indic-pot-match absolute'
                style={{
                    zIndex: 100,
                    backgroundImage: `url(${pixm1})`
                }} ></div>
            <div className='card-indic-pot-match absolute'
                style={{
                    transform: 'rotate(5deg)',
                    transformOrigin: 'bottom left',
                    backgroundImage: `url(${pixm2})`
                }} ></div>
            <span className="material-icons-round"
                style={{
                    position: 'absolute',
                    fontSize: 50,
                    color: 'white',
                    zIndex: 101
                }}
            > favorite</span>
            <h4 style={{zIndex: 101}} >{rootStore.matchStore.potMatches.length < 9? rootStore.matchStore.potMatches.length: '9+'}</h4>
            
        </div>
    )
})